export default "__VITE_ASSET__C$jjLMs$__"